import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@pearsontechnology/aero-components';
import { FormattedDate } from 'react-intl';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';

import cohortShape from 'Workspace/types/cohorts/cohort';
import SharingDialog from 'Workspace/components/SharingDialog';
import WorkspaceHeader from 'Workspace/components/WorkspaceHeader';
import { commandGrantPermissionOnCohort } from 'containers/ConnectionManager/actions';
import tinycolor from 'tinycolor2';
import { ThemeProvider, withTheme } from 'styled-components';
import themes from 'containers/App/themes';

import InlineTextInput from './InlineTextInput';

import {
  HeaderContainer,
  HeaderDetailsContainer,
  HeaderChipTextContainer,
  CohortNameContainer,
  SharingDialogWrapper,
  HeaderDetailsRow,
  InstructorsTextContainer,
} from './styles';

import messages from './messages';

const CohortPageHeader = ({ cohort, title, onRevoke, theme, updateCohort, ...rest }) => {
  const { name, startDate, endDate } = cohort.summary;

  let bannerPattern;
  let bannerImage;
  let color = theme['color.primary.dark'];

  if (cohort.settings) {
    bannerPattern = cohort.settings.bannerPattern;
    bannerImage = cohort.settings.bannerImage;
    color = cohort.settings.color || color;
  }

  const headerBgColor = bannerImage ? '#000000' : color;

  return (
    <ThemeProvider theme={tinycolor(color).isLight() ? themes.light : themes.dark}>
      <HeaderContainer
        bannerImage={bannerImage}
        bannerPattern={bannerPattern}
        bgColor={headerBgColor}
        {...rest}
      >
        <WorkspaceHeader
          title={title}
          bgColor={headerBgColor}
        />
        <HeaderDetailsRow>
          <HeaderDetailsContainer>
            <CohortNameContainer>
              <InlineTextInput value={name} onChange={(newName) => updateCohort({ name: newName })} />
              <Chip white>
                <HeaderChipTextContainer bgColor={headerBgColor}>
                  <FormattedDate
                    value={new Date(startDate)}
                    year="numeric"
                    month="short"
                  />
                  {endDate &&
                    <Fragment>
                      <span> &mdash; </span>
                      <FormattedDate
                        value={new Date(endDate)}
                        year="numeric"
                        month="short"
                      />
                    </Fragment>
                  }
                </HeaderChipTextContainer>
              </Chip>
            </CohortNameContainer>
          </HeaderDetailsContainer>
          {cohort.collaborators &&
            <SharingDialogWrapper>
              <InstructorsTextContainer bgColor={headerBgColor}>
                {intl.formatMessage(messages.instructors)}
              </InstructorsTextContainer>
              <ThemeProvider theme={theme.themeId === 'dark' ? themes.dark : themes.light}>
                <SharingDialog
                  whiteAvatarStackButton={!tinycolor(color).isLight()}
                  blackAvatarStackButton={tinycolor(color).isLight()}
                  avatarBorderColor={bannerImage ? '#000000' : color}
                  sharedWith={cohort.collaborators}
                  refId={cohort.summary.cohortId}
                  hasStorageInPermissionGrant
                  permissionGrantCommand={commandGrantPermissionOnCohort}
                  handleDelete={onRevoke}
                />
              </ThemeProvider>
            </SharingDialogWrapper>
          }
        </HeaderDetailsRow>
      </HeaderContainer>
    </ThemeProvider>
  );
};

CohortPageHeader.propTypes = {
  cohort: cohortShape,
  onRevoke: PropTypes.func,
  title: PropTypes.string,
  theme: PropTypes.object,
  updateCohort: PropTypes.func,
};

export default withTheme(CohortPageHeader);
